import { formatEditorValueFromJson } from 'modules/aceEditor';
import { MessageMedium } from 'modules/graphql/types/GraphQLMessageMedium';
import {
  EmailContentDefinition,
  InAppContentDefinition,
  InAppDestination,
  MediumContent,
  PushContentDefinition,
  TemplateAndContentCommonFields,
} from 'modules/graphql/types';
import { WhatsApp } from 'constants/messageMediums';
import { TemplateType } from 'constants/templateTypes';
import { SelectedMessageMedium, TemplateCampaign } from '../common/types';
import { getMessageFormat } from '../EditInApp/utils';

const formatJsonPayload = (
  data: InAppContentDefinition | PushContentDefinition | EmailContentDefinition,
) => formatEditorValueFromJson(data.payload);

type GetTargetDestinationParams = {
  inAppMediumData: InAppContentDefinition;
  campaign?: TemplateCampaign;
  isRokuTemplatingOn: boolean;
};

export const getTargetDestinations = ({
  inAppMediumData,
  campaign,
  isRokuTemplatingOn,
}: GetTargetDestinationParams) => {
  const isCampaignFlow = !!campaign?.id;

  const isNewTemplate = !inAppMediumData?.destinations;

  if (isNewTemplate && isRokuTemplatingOn && isCampaignFlow && campaign?.mobileAppIds?.length) {
    switch (campaign.mobileAppIds[0]) {
      // MobileAppId of 0 is a roku device target
      case 0:
        return [InAppDestination.Roku];
      // MobileAppId of -1 is 'EVERYTHING'
      case -1:
        return [InAppDestination.Roku, InAppDestination.Browser, InAppDestination.Mobile];
      // All other cases are app and browser
      default:
        return [InAppDestination.Browser, InAppDestination.Mobile];
    }
  }
};

export const prepInitialData = (
  medium: SelectedMessageMedium,
  commonFields: TemplateAndContentCommonFields,
  mediumContent: MediumContent,
  campaign?: TemplateCampaign,
  isRokuTemplatingOn = false,
  isNewLocale = false,
) => {
  const destinations =
    medium === MessageMedium.InApp
      ? getTargetDestinations({
          inAppMediumData: mediumContent as InAppContentDefinition,
          campaign,
          isRokuTemplatingOn,
        })
      : null;

  return JSON.stringify({
    ...commonFields,
    mediumData: {
      ...mediumContent,
      ...(medium === MessageMedium.InApp ||
      medium === MessageMedium.Push ||
      medium === MessageMedium.Email
        ? {
            payload: formatJsonPayload(
              mediumContent as
                | InAppContentDefinition
                | PushContentDefinition
                | EmailContentDefinition,
            ),
          }
        : {}),
      ...(medium === MessageMedium.InApp
        ? { messageFormat: getMessageFormat(mediumContent as InAppContentDefinition) }
        : {}),
      ...(isNewLocale &&
      medium === WhatsApp &&
      commonFields?.templateType === TemplateType.BusinessInitiated
        ? {
            metaApprovalStatus: null, // Defaulting to null for use cases where template has been approved/in review already
          }
        : {}),
      ...(destinations ? { destinations } : {}),
    },
    messageType: {
      ...commonFields.messageType,
    },
  });
};
